import { useEffect, useState } from 'react';
import Task from './main/Task';
import DaysSection from './main/DaysSection';
import toFarsiNumber from './tools/toFarsiNumbers';

export default function Main({
  tasks,
  numTasks,
  onTaskDoneToggle,
  selectedDay,
  today,
  onChangeDay,
  onSelectTask,
  deleteMode,
  onCancelDelete,
  onDeleteTasks,
  numDays,
}) {
  const [deletes, setDeletes] = useState([]);
  const numDeletes = deletes.length;

  useEffect(() => {
    setDeletes([]);
  }, [deleteMode]);

  function handleSelectForDelete(id) {
    setDeletes(deletes =>
      deletes.includes(id) ? deletes.filter(d => d !== id) : [...deletes, id]
    );
  }

  function handleCancelDelete() {
    setDeletes([]);
    onCancelDelete();
  }

  function handleConfirmDelete() {
    onDeleteTasks(deletes);

    setDeletes([]);
  }

  return (
    <div className="flex flex-col ">
      {/* days section */}
      <div className=" overflow-x-auto bg-primary mb-4">
        <DaysSection
          today={today}
          selectedDay={selectedDay}
          onChangeDay={onChangeDay}
          numDays={numDays}
        />
      </div>

      {/* tasks section*/}
      <div className="px-6">
        {/* top container */}
        <div className=" mb-7">
          <div>
            {deleteMode ? (
              <DeleteLabel
                onCancelDelete={handleCancelDelete}
                onConfirmDelete={handleConfirmDelete}
                numDeletes={numDeletes}
              />
            ) : numTasks > 0 ? (
              <h4 className="text-2xl font-bold tracking-tighter">
                فعالیت های من
              </h4>
            ) : (
              <p className="text-md text-center max-w-xs mx-auto text-black/30 mt-10">
                فعالیتی وجود ندارد، برای افزودن فعالیت میتوانید از دکمه" اضافه
                کردن" در بالای صفحه استفاده کنید
              </p>
            )}
          </div>
        </div>

        {/* tasks container*/}
        <div className="flex flex-col space-y-4 pb-6 ">
          {tasks.map(task => (
            <Task
              task={task}
              key={task.id}
              onTaskDoneToggle={onTaskDoneToggle}
              onSelectTask={onSelectTask}
              deleteMode={deleteMode}
              selectedForDelete={deletes.includes(task.id)}
              onSelectForDelete={handleSelectForDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function DeleteLabel({ onCancelDelete, numDeletes, onConfirmDelete }) {
  return (
    <div className="flex flex-wrap items-center gap-4 justify-between">
      <h4 className="text-xl font-bold tracking-tighter">
        {numDeletes > 0
          ? `${toFarsiNumber(numDeletes)} مورد حذف خواهد شد`
          : 'موارد حذفی را انتخاب کنید'}
      </h4>

      <div className="flex justify-end space-x-2 max-w-xs grow-1">
        {numDeletes > 0 && (
          <button
            className="px-8 py-3 btn-primary font-bold grow-1"
            onClick={onConfirmDelete}
          >
            تایید
          </button>
        )}
        <button
          className="px-6 py-3 rounded-lg  text-primary border-2 border-primary font-bold grow-0"
          onClick={onCancelDelete}
        >
          انصراف
        </button>
      </div>
    </div>
  );
}
